<template>
  <div id="welcome"
       class="container-fluid d-flex flex-column justify-content-between">
    <no-active-main-component v-if="campaignClass === 'no-campaign'"></no-active-main-component>
    <may24th-main-component v-else-if="campaignClass === 'may24th'"></may24th-main-component>
    <september6th-main-component v-else-if="campaignClass === 'september6th'"></september6th-main-component>
    <september15th-main-component v-else-if="campaignClass === 'september15th'"></september15th-main-component>
    <september22th-main-component v-else-if="campaignClass === 'september22th'"></september22th-main-component>
    <november1st-main-component v-else-if="campaignClass === 'november1st'"></november1st-main-component>
    <christmas24st-main-component v-else-if="campaignClass === 'christmas24st'"></christmas24st-main-component>
    <new-year31st-main-component v-else-if="campaignClass === 'newYear31st'"></new-year31st-main-component>
    <march3th-main-component v-else-if="campaignClass === 'march3th'"></march3th-main-component>
    <div class="row">
      <div class="col d-flex flex-column align-items-end">
        <no-active-slogan-component v-if="campaignClass === 'no-campaign'"></no-active-slogan-component>
        <may24th-slogan-component v-else-if="campaignClass === 'may24th'"></may24th-slogan-component>
        <september6th-slogan-component v-else-if="campaignClass === 'september6th'"></september6th-slogan-component>
        <september15th-slogan-component v-else-if="campaignClass === 'september15th'"></september15th-slogan-component>
        <september22th-slogan-component v-else-if="campaignClass === 'september22th'"></september22th-slogan-component>
        <november1st-slogan-component v-else-if="campaignClass === 'november1st'"></november1st-slogan-component>
        <christmas24st-slogan-component v-else-if="campaignClass === 'christmas24st'"></christmas24st-slogan-component>
        <new-year31st-slogan-component v-else-if="campaignClass === 'newYear31st'"></new-year31st-slogan-component>
        <march3th-slogan-component v-else-if="campaignClass === 'march3th'"></march3th-slogan-component>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import NoActiveSloganComponent from "@/components/campaigns/no-active-slogan-component";
import May24thSloganComponent from "@/components/campaigns/may24th-slogan-component";
import September6thSloganComponent from "@/components/campaigns/september6th-slogan-component";
import NoActiveMainComponent from "@/components/campaigns/no-active-main-component";
import May24thMainComponent from "@/components/campaigns/may24th-main-component";
import September6thMainComponent from "@/components/campaigns/september6th-main-component";
import September15thMainComponent from "@/components/campaigns/september15th-main-component";
import September15thSloganComponent from "@/components/campaigns/september15th-slogan-component";
import September22thSloganComponent from "@/components/campaigns/september22th-slogan-component";
import September22thMainComponent from "@/components/campaigns/september22th-main-component";
import November1stMainComponent from "@/components/campaigns/november1st-main-component";
import November1stSloganComponent from "@/components/campaigns/november1st-slogan-component";
import NewYear31stMainComponent from "@/components/campaigns/newYear31st-main-component";
import NewYear31stSloganComponent from "@/components/campaigns/newYear31st-slogan-component";
import Christmas24stMainComponent from "@/components/campaigns/christmas24st-main-component";
import Christmas24stSloganComponent from "@/components/campaigns/christmas24st-slogan-component";
import March3thSloganComponent from "@/components/campaigns/march3th-slogan-component";
import March3thMainComponent from "@/components/campaigns/march3th-main-component";

export default {
  name: "welcome-component",
  components: {
    March3thMainComponent,
    March3thSloganComponent,
    Christmas24stSloganComponent,
    Christmas24stMainComponent,
    NewYear31stSloganComponent,
    NewYear31stMainComponent,
    November1stSloganComponent,
    November1stMainComponent,
    September22thMainComponent,
    September22thSloganComponent,
    September15thSloganComponent,
    September15thMainComponent,
    September6thMainComponent,
    May24thMainComponent,
    NoActiveMainComponent,
    September6thSloganComponent,
    May24thSloganComponent,
    NoActiveSloganComponent,
  },
  computed: {
    ...mapGetters({
      campaignClass: 'campaignClass'
    })
  },
}
</script>

<style scoped>
#welcome {
  min-height: 100vh;
  min-height: calc(100vh - 81px);
}

.site-title-div {
  border-bottom: 1px solid #757575;
}

/*size sm*/
@media (min-width: 576px) {
  .site-title-div {
    border-right: 1px solid #757575;
    border-bottom: none;
  }
}
</style>
